const entryType = {
  DEPOSIT: 'DEPOSIT',
  EXPIRED_DEPOSIT: 'EXPIRED_DEPOSIT',
  PENDING_DEPOSIT: 'PENDING_DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  BATCH: 'BATCH',
  REFUND: 'REFUND',
  PENDING_DEPOSIT_REFUND: 'PENDING_DEPOSIT_REFUND',
  DEPOSIT_REFUND: 'DEPOSIT_REFUND',
  CANCELLED_DEPOSIT_REFUND: 'CANCELLED_DEPOSIT_REFUND'
};

module.exports = entryType;
